import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import css from './CheckBox.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CheckBox = function CheckBox(_ref) {
  var ariaLabel = _ref.ariaLabel,
      centered = _ref.centered,
      checked = _ref.checked,
      label = _ref.label,
      name = _ref.name,
      _onChange = _ref.onChange,
      required = _ref.required,
      value = _ref.value;
  return /*#__PURE__*/_jsx("div", {
    className: cc([css.root, _defineProperty({}, css.centered, centered)]),
    children: /*#__PURE__*/_jsxs("label", {
      className: css.label,
      htmlFor: "checkbox-".concat(name),
      children: [/*#__PURE__*/_jsx("input", {
        "aria-label": ariaLabel || label,
        className: css.input,
        checked: checked,
        type: "checkbox",
        id: "checkbox-".concat(name),
        name: name,
        onChange: function onChange() {
          _onChange({
            target: {
              name: name,
              value: value,
              label: label
            }
          });
        },
        required: required
      }), /*#__PURE__*/React.isValidElement(label) ? label : /*#__PURE__*/_jsx("span", {
        className: css.text,
        dangerouslySetInnerHTML: {
          __html: label
        }
      })]
    })
  });
};

CheckBox.defaultProps = {
  centered: false,
  required: false
};
CheckBox.propTypes = {
  ariaLabel: PropTypes.string,
  centered: PropTypes.bool,
  checked: PropTypes.bool.isRequired,
  label: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.element]).isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number, PropTypes.shape]).isRequired
};
export default CheckBox;